document.addEventListener('DOMContentLoaded', function () {
  var productForm = document.querySelector('.shopify-product-form');
  var addToCartContainer = document.querySelector('.product-add-to-cart-container');

  var productFormObserver = new MutationObserver(function () {
    var recharge = productForm.querySelector('.rc-container-wrapper');

    if (recharge) {
      productFormObserver.disconnect();

      addToCartContainer.prepend(recharge);
    }
  });

  productFormObserver.observe(productForm, { childList: true });
});
